<div class="terms-of-condition">
 
        <h1>Terms and Conditions</h1>
        <p><strong>Effective Date:</strong> 1.12.2024</p>
    
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing, downloading, or using the AMMSAS application, you agree to these Terms and Conditions. If you do not agree, you must not use the app.</p>
    
        <h2>2. Service Description</h2>
        <p>AMMSAS provides tools for managing schedules, tasks, and other related functionalities for musicians and their teams. While we strive to ensure the functionality and reliability of the app, we do not guarantee uninterrupted or error-free services.</p>
    
        <h2>3. User Responsibilities</h2>
        <ul>
            <li>You agree to use AMMSAS only for lawful purposes.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You acknowledge that any data you input, share, or upload is your responsibility.</li>
        </ul>
    
        <h2>4. Limitations of Liability</h2>
        <ul>
            <li><span class="highlight">No Guarantee of Accuracy:</span> While we aim to provide a reliable service, AMMSAS does not guarantee the accuracy or completeness of the information provided through the app.</li>
            <li><span class="highlight">Use at Your Own Risk:</span> You acknowledge that any reliance on the app or its features is at your own discretion and risk.</li>
            <li><span class="highlight">No Liability:</span> AMMSAS, its owners, developers, and partners are not liable for any direct, indirect, incidental, consequential, or other damages resulting from:
                <ul>
                    <li>Use of the app.</li>
                    <li>Inability to access or use the app.</li>
                    <li>Loss of data or unauthorized access.</li>
                </ul>
            </li>
        </ul>
    
        <h2>5. No Responsibility for Content</h2>
        <p>We are not responsible for the content you or other users create, share, or manage within the app. You must ensure that any data you input or share complies with applicable laws, including GDPR.</p>
    
        <h2>6. User Data and Privacy</h2>
        <p>AMMSAS collects and processes user data in accordance with our <strong>Privacy Policy</strong> and applicable EU data protection laws, including the General Data Protection Regulation (GDPR). By using the app, you consent to the collection, storage, and processing of your data as outlined in our Privacy Policy.</p>
    
        <h2>7. Intellectual Property</h2>
        <p>All rights to the AMMSAS app, including its design, features, and content, are reserved by AMMSAS. You may not copy, distribute, modify, or create derivative works from the app without prior written consent.</p>
    
        <h2>8. Modification of Terms</h2>
        <p>AMMSAS reserves the right to modify these Terms and Conditions at any time. Changes will be effective upon posting. Continued use of the app constitutes your acceptance of the modified Terms and Conditions.</p>
    
        <h2>9. Termination</h2>
        <p>We reserve the right to suspend or terminate your access to AMMSAS at any time for violating these terms or for any other reason, with or without notice.</p>
    
        <h2>10. Governing Law</h2>
        <p>These Terms and Conditions are governed by and construed in accordance with the laws of the European Union. Any disputes arising from the use of AMMSAS will be subject to the exclusive jurisdiction of the courts within the EU.</p>
    
        <h2>11. Disclaimer of Warranty</h2>
        <p>AMMSAS is provided "as is" and "as available." We disclaim all warranties, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
    
        <h2>12. Indemnification</h2>
        <p>You agree to indemnify and hold harmless AMMSAS, its affiliates, partners, and employees from any claims, liabilities, damages, losses, or expenses arising from:</p>
        <ul>
            <li>Your use of the app.</li>
            <li>Your breach of these Terms and Conditions.</li>
            <li>Any violation of applicable laws.</li>
        </ul>
    
        <h2>13. Contact Us</h2>
        <p>For any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
        <ul>
            <li>E-Mail: info&#64;in-somnia.eu</li>
            <li>Adresse: Rauchkofelweg 28, 9900 Lienz, Austria</li>
        </ul>
    
        <p><em>By using AMMSAS, you acknowledge that the app is a tool to assist you but does not guarantee outcomes, assume responsibility, or replace professional advice. You are solely responsible for ensuring compliance with relevant laws and managing your data securely.</em></p>

    

        <h1>Allgemeine Geschäftsbedingungen</h1>
        <p><strong>Gültig ab:</strong> 1.12.2024</p>
    
        <h2>1. Zustimmung zu den Bedingungen</h2>
        <p>Durch den Zugriff auf die AMMSAS-App, das Herunterladen oder die Nutzung erklären Sie sich mit diesen Allgemeinen Geschäftsbedingungen einverstanden. Wenn Sie nicht zustimmen, dürfen Sie die App nicht verwenden.</p>
    
        <h2>2. Beschreibung des Dienstes</h2>
        <p>AMMSAS bietet Werkzeuge zur Verwaltung von Terminen, Aufgaben und anderen Funktionen für Musiker und ihre Teams. Obwohl wir uns bemühen, die Funktionalität und Zuverlässigkeit der App zu gewährleisten, garantieren wir keine ununterbrochenen oder fehlerfreien Dienste.</p>
    
        <h2>3. Pflichten des Nutzers</h2>
        <ul>
            <li>Sie verpflichten sich, AMMSAS nur für rechtmäßige Zwecke zu nutzen.</li>
            <li>Sie sind verantwortlich für die Geheimhaltung Ihrer Kontodaten.</li>
            <li>Sie erkennen an, dass alle von Ihnen eingegebenen, geteilten oder hochgeladenen Daten in Ihrer Verantwortung liegen.</li>
        </ul>
    
        <h2>4. Haftungsbeschränkung</h2>
        <ul>
            <li><span class="highlight">Keine Garantie für Genauigkeit:</span> Obwohl wir zuverlässige Dienste bereitstellen möchten, garantiert AMMSAS nicht die Genauigkeit oder Vollständigkeit der über die App bereitgestellten Informationen.</li>
            <li><span class="highlight">Nutzung auf eigene Gefahr:</span> Sie erkennen an, dass jegliches Vertrauen auf die App oder ihre Funktionen auf eigenes Risiko erfolgt.</li>
            <li><span class="highlight">Haftungsausschluss:</span> AMMSAS, seine Eigentümer, Entwickler und Partner haften nicht für direkte, indirekte, zufällige, Folgeschäden oder andere Schäden, die durch Folgendes entstehen:
                <ul>
                    <li>Die Nutzung der App.</li>
                    <li>Die Unfähigkeit, auf die App zuzugreifen oder diese zu nutzen.</li>
                    <li>Datenverlust oder unbefugter Zugriff.</li>
                </ul>
            </li>
        </ul>
    
        <h2>5. Keine Verantwortung für Inhalte</h2>
        <p>Wir übernehmen keine Verantwortung für die Inhalte, die Sie oder andere Nutzer in der App erstellen, teilen oder verwalten. Sie müssen sicherstellen, dass alle von Ihnen eingegebenen oder geteilten Daten den geltenden Gesetzen, einschließlich der DSGVO, entsprechen.</p>
    
        <h2>6. Nutzerdaten und Datenschutz</h2>
        <p>AMMSAS sammelt und verarbeitet Nutzerdaten gemäß unserer <strong>Datenschutzrichtlinie</strong> und den geltenden EU-Datenschutzgesetzen, einschließlich der Datenschutz-Grundverordnung (DSGVO). Durch die Nutzung der App stimmen Sie der Sammlung, Speicherung und Verarbeitung Ihrer Daten gemäß unserer Datenschutzrichtlinie zu.</p>
    
        <h2>7. Geistiges Eigentum</h2>
        <p>Alle Rechte an der AMMSAS-App, einschließlich ihres Designs, ihrer Funktionen und Inhalte, liegen bei AMMSAS. Sie dürfen die App ohne vorherige schriftliche Zustimmung weder kopieren, verteilen, modifizieren noch abgeleitete Werke erstellen.</p>
    
        <h2>8. Änderung der Bedingungen</h2>
        <p>AMMSAS behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen jederzeit zu ändern. Änderungen werden mit der Veröffentlichung wirksam. Die fortgesetzte Nutzung der App gilt als Ihre Zustimmung zu den geänderten Allgemeinen Geschäftsbedingungen.</p>
    
        <h2>9. Kündigung</h2>
        <p>Wir behalten uns das Recht vor, Ihren Zugang zu AMMSAS jederzeit und ohne Vorankündigung auszusetzen oder zu beenden, wenn Sie gegen diese Bedingungen verstoßen oder aus einem anderen Grund.</p>
    
        <h2>10. Anwendbares Recht</h2>
        <p>Diese Allgemeinen Geschäftsbedingungen unterliegen den Gesetzen der Europäischen Union. Alle Streitigkeiten im Zusammenhang mit der Nutzung von AMMSAS unterliegen der ausschließlichen Gerichtsbarkeit der EU-Gerichte.</p>
    
        <h2>11. Haftungsausschluss</h2>
        <p>AMMSAS wird "wie besehen" und "wie verfügbar" bereitgestellt. Wir schließen alle Garantien aus, einschließlich, aber nicht beschränkt auf stillschweigende Garantien der Marktgängigkeit, Eignung für einen bestimmten Zweck und Nichtverletzung von Rechten.</p>
    
        <h2>12. Schadloshaltung</h2>
        <p>Sie erklären sich bereit, AMMSAS, seine verbundenen Unternehmen, Partner und Mitarbeiter von jeglichen Ansprüchen, Verbindlichkeiten, Schäden, Verlusten oder Kosten freizustellen, die sich ergeben aus:</p>
        <ul>
            <li>Ihrem Gebrauch der App.</li>
            <li>Ihrem Verstoß gegen diese Allgemeinen Geschäftsbedingungen.</li>
            <li>Jeglicher Verletzung geltender Gesetze.</li>
        </ul>
    
        <h2>13. Kontakt</h2>
        <p>Bei Fragen oder Bedenken bezüglich dieser Allgemeinen Geschäftsbedingungen kontaktieren Sie uns bitte unter:</p>
        <ul>
            <li>E-Mail: info&#64;in-somnia.eu</li>
            <li>Adresse: Rauchkofelweg 28, 9900 Lienz, Austria</li>
        </ul>
    
        <p><em>Durch die Nutzung von AMMSAS erkennen Sie an, dass die App ein Hilfsmittel ist, das Ergebnisse nicht garantiert, keine Verantwortung übernimmt und keinen professionellen Rat ersetzt. Sie sind allein verantwortlich für die Einhaltung der relevanten Gesetze und die sichere Verwaltung Ihrer Daten.</em></p>

</div>

<style>
    .terms-of-condition {
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
    
        h1, h2 {
            color: var(--p-primary-color);
        }
        h1 {
            text-align: center;
            margin-bottom: 20px;
        }
        h2 {
            margin-top: 20px;
        }
        p {
            margin: 10px 0;
        }
        ul {
            margin: 10px 0 10px 20px;
        }
        .highlight {
            color: #d9534f;
            font-weight: bold;
        }
    }
</style>